<template>
  <div class="horizon-container">
    <div class="flex-1 w-0 h-100 flex-column ptb-10 plr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-10 mr-10">
          <div class="flex align-center mr-20 cursor">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-f5971d" >出纳流水账列表</div>
          </div>
        </div>
        <div class="flex  align-center ">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="供货开始时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="供货结束时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="flex align-center ml-10">
          <el-select class="flex-1" v-model="selectSupplier" >
            <el-option v-for="(item, index) in supplier" :key="index" :label="item.name" :value="index"></el-option>
          </el-select>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable @keyup.enter.native="onSearch"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="onSearch">搜索</button>
        </div>
      </div>
      <div class="mb-5 flex flex-wrap">
        <div class="flex align-center mr-20 mb-5 font-12-ff5555 cursor" v-for="(item, index) in btnList" :key="index" @click="changeIndex(index)">
          <img :src="index === btnIndex ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'" class=" mr-5" :class="item.iconStatus ===1 ? 'icon-12-14':'icon-14'" alt="">
          <div>{{item}}</div>
        </div>
        <div class="flex flex-1 justify-end">
          <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" >
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            <div>导出Excel</div>
          </div>
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" :table-footer="tableFooter2" @on-detail="onDetail" :table-data="tableData" :loading="loading" :column-data="columnData"></erp-table>
        </div>
        <pagination :page-size="pages" :page-no="page" v-model="page" :page-total="limit" :total="total" @on-jump="jump"></pagination>
      </div>
    </div>
    <el-dialog :title="currentBill.name || '款项详情'" :visible.sync="isDetailShow" width="85%" class="handlePlan">
      <div>
        <div class="bg-f3f4f7 flex text-left plr-20 ptb-10 align-center">
          <div class="flex-1 mr-40">
            <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">收款单号：</span>{{currentBill.number}}</div>
            <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">纸质单号：</span>{{currentBill.writingNumber}}</div>
          </div>
          <div class="flex-1 mr-40">
            <div class="font-12-30313a"><span class="font-12-b9b9b9">操作人员：</span>{{currentBill.operatorName}}</div>
            <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">账户：</span>{{currentBill.account}}</div>
          </div>
          <div class="flex-2">
            <div class="font-12-30313a flex">
              <div class="flex"><span class="font-12-b9b9b9">客户信息：</span>{{currentBill.customerName}}/{{currentBill.customerTelephone}}/{{currentBill.customerAddress}}</div>
              <div class="flex flex-1 justify-end"><span class="font-12-b9b9b9">开单时间：</span>{{currentBill.createTime ? Utils.formatTime(currentBill.createTime) : '-'}}</div>
            </div>
            <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">单号备注：</span>{{currentBill.description}}</div>
          </div>
        </div>
        <div style="height: 360px">
          <erp-table :table-data="currentBill.orderBillItemList" :column-data="tableArray1" :table-footer="tableFooter1"></erp-table>
        </div>
      </div>
    </el-dialog>
    <div class="filtrate">
      <el-dialog :visible.sync="isDetailShow2" width="85%" :show-close="false">
        <div class="header">
          <!--<div class="font-bold " :class="founddetail.status === 1 ? 'font-22-30313a': 'font-22-ff5555'">{{founddetail.status === 1 ? '收款单据':'退款单据'}}</div>-->
          <div class="font-bold font-22-30313a" >{{currentBill.name || '单据详情'}}</div>
          <i class="el-icon-close close1"  @click="isDetailShow2 = false"></i>
        </div>
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img :src="founddetail.status ===1 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'" style="width: 15px;height: auto" alt=""></div>-->
        <div class="p-absolute" style="top: 0;left: 20px;"><img :src="currentBill.status === 2 ?  '/static/images/yijizhang.png' : '/static/images/weijizhang.png'" style="width: 15px;height: auto" alt=""></div>
        <div class="bg-f3f4f7 plr-20 ptb-10">
          <div class=" flex text-left align-center">
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">单据编号：</span>{{currentBill.number}}</div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">付款账号：</span>
                {{currentBill.account}}
              </div>
            </div>
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">供应商：</span>{{currentBill.businessName}}</div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">对方账号：</span>
                {{currentBill.counterAccount}}
              </div>
            </div>
            <div class="flex-2">
              <div class="font-12-30313a flex mb-5 align-center">
                <div class="flex"><span class="font-12-b9b9b9">开单人员：</span>{{currentBill.operatorName}}</div>
                <div class="flex flex-1 justify-end"><span class="font-12-b9b9b9">开单时间：</span>{{Utils.formatTime(currentBill.createTime)}}</div>
              </div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">单据摘要：</span>
                {{currentBill.description}}
              </div>
            </div>
          </div>
        </div>
        <div class="plr-20 ptb-10">
          <div style="height: 250px">
            <erp-table :table-data="currentBill.orderBillItemList" :column-data="dialogTableColumn" :table-footer="tableFooter"></erp-table>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import ErpTable from '../../components/ErpTable'
import XEUtils from 'xe-utils'
XEUtils.mixin({
  toAccounting (cellValue) {
    return cellValue === 2 ? '已记账' : cellValue === 1 ? '未记账' : ''
  }
})
export default {
  name: 'cashierFlowAccount',
  components: {Pagination, ErpTable},
  data () {
    return {
      keywords: '',
      page: 1,
      limit: 30,
      pages: 0,
      total: 0,
      startTime: '',
      endTime: '',
      loading: false,
      Index: -1,
      btnList: ['显示全部', '只看付款', '只看收款'],
      btnIndex: 0,
      selectSupplier: 0,
      supplier: [{
        id: '',
        name: '全部供应商'
      }],
      isDetailShow: false,
      isDetailShow2: false,
      tableFooter2: [
        {
          columns: ['receiveAmount', 'payAmount'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          field: 'operate', // 若为操作，则固定为operate
          title: '操作',
          width: '80',
          fixed: 'left',
          isDefine: true,
          child: [{
            className: 'btn-16-bg-85 btn-hover mr-5',
            title: '详情',
            methodName: 'on-detail',
            type: 'btn'
          }]
        }, {
          field: 'status',
          title: '单据状态',
          width: '100',
          formatter: 'toAccounting'
        }, {
          field: 'typeName',
          title: '单据类型',
          width: '100'
        }, {
          field: 'number',
          title: '单据号',
          width: '150'
        }, {
          field: 'account',
          title: '账户',
          width: '120'
        }, {
          field: 'receiveAmount',
          title: '收款金额',
          width: '100'
        }, {
          field: 'payAmount',
          title: '付款金额',
          width: '100'
        }, {
          field: 'createTime',
          title: '编制日期',
          width: '120',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'accountTime',
          title: '记账日期',
          width: '120',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'description',
          title: '摘要',
          minWidth: '200'
        }
      ],
      tableData: [],
      currentBill: {},
      tableFooter1: [
        {
          columns: ['planBill', 'realBill', 'undoBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableArray1: [
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'name',
          title: '款项名称',
          width: '200'
        },
        {
          field: 'planBill',
          title: '应收',
          width: '100'
        },
        {
          field: 'realBill',
          title: '实收',
          width: '100'
        }, {
          field: 'undoBill',
          title: '未收',
          width: '100'
        }, {
          field: 'description',
          title: '说明',
          minWidth: '100'
        }
      ],
      dialogTableColumn: [
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'name',
          title: '单据名称',
          width: '100'
        }, {
          field: 'orderCode',
          title: '材料单据号',
          width: '100'
        }, {
          field: 'planBill',
          title: '应付金额',
          width: '100'
        }, {
          field: 'realBill',
          title: '实付金额',
          width: '100'
        }, {
          field: 'description',
          title: '备注',
          width: ''
        }
      ],
      tableFooter: [
        {
          columns: ['planBill', 'realBill'],
          type: 'sum',
          name: '合计'
        }
      ]
    }
  },
  created () {
    this.axios.post('order/queryBusinessList', {companyId: this.$store.state.companyId}).then(res => {
      if (res.data.success) {
        this.supplier = this.supplier.concat(res.data.data)
      }
    })
    this.getData()
  },
  mounted () {},
  methods: {
    onDetail (row) {
      this.currentBill = row
      if (parseInt(row.billType) === 1) {
        this.isDetailShow2 = true
      } else {
        this.isDetailShow = true
      }
    },
    getData () {
      let params = {
        companyId: this.$store.state.companyId,
        type: this.btnIndex === 0 ? '' : this.btnIndex,
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        startTime: this.startTime,
        endTime: this.endTime
      }
      this.axios.post('customerFinance/runningAccountList', params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.pages = res.data.data.pages
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSearch () {
      this.page = 1
      this.getData()
    },
    changeIndex (index) {
      this.btnIndex = index
      this.page = 1
      this.getData()
    },
    jump (page) {
      this.page = page
      this.getData()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .filtrate /deep/ .el-dialog__wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .filtrate /deep/ .el-dialog{
    border-radius: 6px;
    margin: 0!important;
    max-height: 100%;
    height: auto;
  }
  .filtrate /deep/ .el-dialog__header{
    display: none;
  }
  .filtrate /deep/ .el-dialog__body{
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .header{
    border-bottom:1px solid #e2e2e2;
    padding: 14px;
    position: relative;
  }
  .close1{
    color: #30313a;
    font-size: 22px;
    font-weight: bold;
    position: absolute;
    top:10px;
    right: 10px;
    background: #ffffff;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/cashierFlowAccount.vue